import { graphql } from 'client/app/gql';

export const QUERY_DISCO_CALCULATE_VOLUMES = graphql(/* GraphQL */ `
  query DiscoCalculateVolumes($request: CalculateVolumesRequestBlob!) {
    discoCalculateVolumes(request: $request)
  }
`);
